import type { AppVersion, Platform } from '@/types'
import { isBackendHistoricalPackage, isPlatformPackageUploaded } from './platform'

/** 版本下展示的一个平台；reusedFrom 为沿用的历史版本号 */
export interface VersionPlatformEntry {
  platform: Platform
  reusedFrom?: string
}

/**
 * 侧栏 / 列表里版本下的平台 = 本版服务的端，与状态无关：
 * 本次新传 + 沿用（标 reusedFrom）。数据不全时退回声明平台，避免节点下空白。
 */
export function versionPlatformEntries(version: AppVersion): VersionPlatformEntry[] {
  if (version.main_package && !version.main_package.needs_platform_packages) {
    return version.platforms.map((platform) => ({ platform }))
  }

  const entries: VersionPlatformEntry[] = []
  for (const pkg of version.platform_packages ?? []) {
    if (entries.some((e) => e.platform === pkg.platform)) continue
    const uploaded: boolean = isPlatformPackageUploaded(pkg)
    if (uploaded) {
      entries.push({ platform: pkg.platform })
    } else if (isBackendHistoricalPackage(pkg)) {
      entries.push({ platform: pkg.platform, reusedFrom: pkg.package_version })
    }
  }
  return entries.length
    ? entries
    : version.platforms.map((platform) => ({ platform }))
}
